import type { IconSvgObject } from './types';

const SimcardDualIcon: IconSvgObject = [
  ["path", { d: "M16 16H20C21.1046 16 22 15.1046 22 14V6.89813C22 6.32686 21.7557 5.78285 21.3287 5.40331L18.0683 2.50518C17.7022 2.17976 17.2294 2 16.7396 2H12C10.8954 2 10 2.89543 10 4V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 20V8C2 6.89543 2.89543 6 4 6H9.78607C10.2478 6 10.6952 6.15973 11.0525 6.45209L15.2665 9.89984C15.7307 10.2797 16 10.8479 16 11.4478V20C16 21.1046 15.1046 22 14 22H4C2.89543 22 2 21.1046 2 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SimcardDualIcon;
